import {
  createMaxMessage,
  createMinMessage,
  createRequiredMessage,
} from '@domain/validations';
import * as Yup from 'yup';

const nextDay = new Date(); 
nextDay.setDate(nextDay.getDate() + 1);
nextDay.setHours(0, 0, 0, 0);

export const getCourseValidationSchema = () => {
  const courseValidationSchema = Yup.object<any>().shape({
    number: Yup.string()
      .required(createRequiredMessage('number'))
      .nullable()
      .matches(
        /^[A-Za-z]{3}\d{4}$/,
        'Field must start with 3 letters and be followed by 4 numbers'
      ),
    name: Yup.string()
      .min(1, createMinMessage('name', 1))
      .max(100, createMaxMessage('name', 100))
      .required(createRequiredMessage('name')),
    description: Yup.string()
      .min(1, createMinMessage('description', 1))
      .max(10000, createMaxMessage('description', 10000))
      .optional(),
    endDate: Yup.date()
      .nullable(),
  });

  return courseValidationSchema;
};
